import { useState } from "react";
import { SEO } from "@/lib/seo";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { MatchCard } from "@/components/matchday/MatchCard";
import { MEDIA } from "@/config/media";
import { cn } from "@/lib/utils";

const upcomingMatch = {
  homeTeam: "Team name goes here",
  awayTeam: "Team name goes here",
  date: "Date goes here",
  kickOff: "KO time goes here",
  competition: "Competition goes here",
  venue: "Venue goes here",
  status: "upcoming",
  platform: "Platform goes here",
};

const previousMatch = {
  homeTeam: "Team name goes here",
  awayTeam: "Team name goes here",
  date: "Date goes here",
  kickOff: "KO time goes here",
  competition: "Competition goes here",
  venue: "Venue goes here",
  status: "completed",
  result: "Result goes here",
};

export default function Matchday() {
  const [tab, setTab] = useState("upcoming");

  return (
    <div data-testid="matchday-page">
      <SEO
        title="Women's Football Matchday Fixtures"
        description="Grassroots women's football matchday fixtures, results and live coverage status from WomensMatchDayLive, covering UK women's grassroots football."
        path="/matchday"
      />
      <PageHero
        eyebrow="Matchday"
        title="Matchday"
        subtitle="Upcoming fixtures and previous coverage from UK women's grassroots football."
        crumbLabel="Matchday"
        backgroundImage={MEDIA.matchdayHero.url}
        backgroundAlt={MEDIA.matchdayHero.alt}
      />

      <section className="bg-brand-black py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-12">
          <div role="tablist" aria-label="Matchday sections" className="flex gap-2 border-b border-border-dark">
            {["upcoming", "previous"].map((key) => (
              <button
                key={key}
                role="tab"
                aria-selected={tab === key}
                data-testid={`matchday-tab-${key}`}
                onClick={() => setTab(key)}
                className={cn(
                  "px-6 py-4 font-subheading text-sm font-semibold uppercase tracking-wide transition-colors",
                  tab === key ? "border-b-2 border-brand-purple text-white" : "text-white/40 hover:text-white/70"
                )}
              >
                {key === "upcoming" ? "Upcoming" : "Previous Coverage"}
              </button>
            ))}
          </div>

          <div className="mt-10 grid gap-6 sm:grid-cols-2">
            {tab === "upcoming" ? (
              <Reveal data-testid="matchday-upcoming-panel">
                <MatchCard match={upcomingMatch} />
                <p className="mt-4 text-sm text-white/40">Upcoming match information goes here.</p>
              </Reveal>
            ) : (
              <Reveal data-testid="matchday-previous-panel">
                <MatchCard match={previousMatch} />
                <p className="mt-4 text-sm text-white/40">Previous match information goes here.</p>
              </Reveal>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
